// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_titulo__22iIs {
    color: #18316e;
    text-align: center;
}

.styles_tituloCadastro__nazok{
    color: #18316e;
    font-size: 1.3rem;
    margin-bottom: 2rem;
}

.styles_containerBotoes__cbFDa {
    display: flex;
    justify-content: space-around;
    margin-top: 2rem;
}

.styles_containerBotoesCadastro__JfEB0 {
    display: flex;
    justify-content: space-between;
    margin-top: 2rem;
}

.styles_botaoNao__63A0z {
    background-color: transparent !important;
    border: 1px solid !important;
    border-color: #18316e !important;
    color: #18316e !important;
    font-family: "Inter" !important;
    font-weight: 400 !important;
    min-width: 5rem;
    text-transform: none !important;
}

.styles_botaoSim__zUOjf {
    background-color: #18316e !important;
    font-family: "Inter" !important;
    font-weight: 400 !important;
    color: #ffffff !important;
    min-width: 5rem;
    text-transform: none !important;
    transition: all 0.3s ease !important;
}`, "",{"version":3,"sources":["webpack://./src/components/CadastroDetalhadoCliente/DadosBancarios/ModalDadosBancarios/styles.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;IACxC,4BAA4B;IAC5B,gCAAgC;IAChC,yBAAyB;IACzB,+BAA+B;IAC/B,2BAA2B;IAC3B,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,oCAAoC;IACpC,+BAA+B;IAC/B,2BAA2B;IAC3B,yBAAyB;IACzB,eAAe;IACf,+BAA+B;IAC/B,oCAAoC;AACxC","sourcesContent":[".titulo {\n    color: #18316e;\n    text-align: center;\n}\n\n.tituloCadastro{\n    color: #18316e;\n    font-size: 1.3rem;\n    margin-bottom: 2rem;\n}\n\n.containerBotoes {\n    display: flex;\n    justify-content: space-around;\n    margin-top: 2rem;\n}\n\n.containerBotoesCadastro {\n    display: flex;\n    justify-content: space-between;\n    margin-top: 2rem;\n}\n\n.botaoNao {\n    background-color: transparent !important;\n    border: 1px solid !important;\n    border-color: #18316e !important;\n    color: #18316e !important;\n    font-family: \"Inter\" !important;\n    font-weight: 400 !important;\n    min-width: 5rem;\n    text-transform: none !important;\n}\n\n.botaoSim {\n    background-color: #18316e !important;\n    font-family: \"Inter\" !important;\n    font-weight: 400 !important;\n    color: #ffffff !important;\n    min-width: 5rem;\n    text-transform: none !important;\n    transition: all 0.3s ease !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titulo": `styles_titulo__22iIs`,
	"tituloCadastro": `styles_tituloCadastro__nazok`,
	"containerBotoes": `styles_containerBotoes__cbFDa`,
	"containerBotoesCadastro": `styles_containerBotoesCadastro__JfEB0`,
	"botaoNao": `styles_botaoNao__63A0z`,
	"botaoSim": `styles_botaoSim__zUOjf`
};
export default ___CSS_LOADER_EXPORT___;
